module.exports = __webpack_public_path__ + "static/media/fr.7204e7f5.svg";